import { render, staticRenderFns } from "./MiddlewareGame.vue?vue&type=template&id=c4c3e266&scoped=true&"
import script from "./MiddlewareGame.vue?vue&type=script&lang=js&"
export * from "./MiddlewareGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c3e266",
  null
  
)

export default component.exports